import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {Service} from '../../../services';
import {LoadingScreenService} from '../../../services/loading-screen/loading-screen.service';
import {MatDialog} from '@angular/material';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/message.service';


@Component({
  selector: 'app-selected-plan-prepaid',
  templateUrl: './selected-plan-prepaid.component.html',
  styleUrls: ['./selected-plan-prepaid.component.sass']
})
export class SelectedPlanPrepaidComponent implements OnInit {
  @Input() index;

  public currentList;
  public postpago;
  public prepago;
  public totalAccountList;
  public type;
  public token: string = sessionStorage.getItem("token");
  public planActual = '';
  public rectaActual;
  public accountSubType;
  public accountType;
  public amount;
  public ivuState;
  public tax;
  public totalPagar;
  public screenView;
  public cycleEndDate;
  public activatedTerms = false;
  public contractOption = 0;
  public activationOption = 0;
  public contractMonthsTxt = '';
  public contractMonths = 0;
  public message = '';
  public orignomo = 0;
  refundView = false;
  public paymentData;
  @Output() updatescreenview = new EventEmitter<any>();
  @Output() updatepayment = new EventEmitter<any>();
  @Output() updatepaymentview = new EventEmitter<any>();
  @Output() updateNroOrder = new EventEmitter<boolean>();
  @Output() checkContract = new EventEmitter;
  @Output() updateNumberOrder = new EventEmitter<String>();
  @Output() updateinitializeData = new EventEmitter();
  @Input() currentPlan;
  @Input() actualPrice;
  @Input() planToChange;
  @Input() descriptions;
  @Input() pricePlan;
  @Input() currentPlanId;
  @Input() nextDate;
  @Input() textoMovil;
  @Input() actualType;
  @Input() currentSoc;
  @Input() nextSoc;
  @Input() subscriberNumber;
  @Input() telefoniaFijo;
  @Input() commitmentOriginalMonths;
  @Input() numberOrder;
  @Input() validatePaymentGreaterThanBalance: boolean;
  @Input() selectBan;
  @Input() accounInfo;
  @Input() id;

  constructor(private global: GlobalService,
              private services: Service,
              public dialog: MatDialog,
              private loadingScreenService: LoadingScreenService,
              private router: Router,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.cycleEndDate = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleEndDateField;
    this.nextDate = this.currentDate(this.cycleEndDate);
    this.currentDate(this.nextDate);
  }

  currentDate(fecha) {
    if (fecha) {
      fecha = new Date(fecha);
    } else {
      fecha = new Date();
    }
    var mes = fecha.getMonth();
    var diaMes = fecha.getDate();
    var diaSemana = fecha.getDay();
    var anio = fecha.getFullYear();
    var dias = new Array('Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado');
    var meses = new Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');
    return dias[diaSemana] + ', ' + diaMes + ' de ' + meses[mes] + ' de ' + anio;
  }

  applyChange() {
    if (this.global.validateSession() === true) {
      let date = new Date();
      let month;
      let month2 = (date.getMonth() + 1);
      let day;
      let day2 = date.getDate();
      let year = date.getFullYear();
      if (month2 < 10) {
        month = "0" + month2;
      } else {
        month = month2;
      }
      if (day2 < 10) {
        day = "0" + day2;
      } else {
        day = day2;
      }
      let effectiveDate = year + "-" + month + "-" + day;
      this.loadingScreenService.startLoading();
      this.services.updateChangePlanPrepaid(this.accounInfo["accountTypeField"], this.accounInfo["accountSubtypeField"], effectiveDate, this.currentSoc, this.nextSoc, this.actualType, this.id, this.token, this.subscriberNumber).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if (data.success == true) {
          this.updateGlobalPrepaidInfo();
          this.updateScreen()
        } else {
          if (data.desc === 'SUCCESS' || data.desc === 'COMPLETED') {
            this.updateGlobalPrepaidInfo();
            this.updateScreen()
          } else {
            this.manageError(data);
          }
        }
      });
    }
  }

  manageError(data) {
    if (data.code === "001") {
      this.global.notif(`Estimado cliente nuestro sistema indica que ha llegado al limite de Cambio de Plan en un mes.`);
      this.updateinitializeData.emit();
      this.messageService.sentMessage("canceled", {
        method: "Estimado cliente nuestro sistema indica que ha llegado al limite de Cambio de Plan en un mes.",
      });
      this.return()

    } else if (data.code === "002") {
      this.refundView = true;
      this.messageService.sentMessage("canceled", {
        method: "Cambio de plan no efectuado.",
      });

    } else if (data.code === "003") {
      this.messageService.sentMessage("canceled", {
        method: "Cambio de plan no efectuado.",
      });
      this.global.notif(`Actualmente el sistema está presentando problemas de comunicación, por favor contacte a Soporte Operacional o intente nuevamente en los próximos minutos.`);
      this.updateinitializeData.emit();
      this.return()
    }
  }

  return() {
    this.router.navigate(['home'])
  }

  updateScreen() {
    this.updateinitializeData.emit();
    this.updatescreenview.emit(3);
    this.updateNroOrder.emit(false);
    this.global.getEvaluatePlanPrepaid();
  }

  updateGlobalPrepaidInfo() {
    this.global.prepaidDataForEvaluate.token = this.token;
    this.global.prepaidDataForEvaluate.socId = Number(this.nextSoc);
    this.global.prepaidDataForEvaluate.subscriber = this.subscriberNumber;
  }

  backPage() {
    if (this.global.validateSession()) {
      this.updatescreenview.emit(1);
    }
  }
}
